import UnavailableProduct from "../components/unavailableProduct/UnavailableProduct";

export default function UnavailableProductPage() {
  return <UnavailableProduct />;
}
